export default __webpack_public_path__ + "static/media/IMG_0029_2_11zon.ac77273c.jpg";